<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative h-100 w-100 bg-white"
  >
    <ErrorPage
      :token="errorData.token"
      :brandRef="errorData.brandRef"
      :image="forgetPasswordImg"
      :titleEn="errorData.errorTitleEN"
      :titleTh="errorData.errorTitleTH"
      :messageEn="errorData.errorMessageEN"
      :messageTh="errorData.errorMessageTH"
      :button="true"
      :buttonText="'Verify Email'"
      @onSubmit="onLoginPage"
    />
  </div>
</template>

<script>
import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import logoChoco from "@/assets/images/logo/logo-choco.png";
import forgetPasswordImg from "@/assets/images/pages/forgor-password/Forgot-link-expire-BP.png";
import ErrorPage from "@/views/pages/error/components/Error.vue";
export default {
  directives: {
    Ripple,
  },
  components: {
    ErrorPage,
  },
  setup() {
    const { decodeParamToken } = useDecodeToken();
    let decodeToken = null;

    let errorCode = {
      TOKEN_EXPIRED: 4006001,
    };

    const errorData = reactive({
      token: null,
      brandRef: null,
      errorId: null,
      errorTitleTH: null,
      errorTitleEN: null,
      errorMessageEN: null,
      errorMessageTH: null,
    });

    const onLoginPage = (url) => {
      if (!decodeToken?.brand_ref) return;
      if (!errorData.token) return;

      router
        .replace({
          path: "/forget-password",
          query: { token: errorData.token },
        })
        .catch(() => {});
    };

    onBeforeMount(() => {
      errorData.token = router.currentRoute.query.token;
      if (decodeParamToken()) {
        decodeToken = decodeParamToken();
        if (decodeToken?.brand_ref) errorData.brandRef = decodeToken?.brand_ref;
        if (decodeToken?.error_id) errorData.errorId = decodeToken?.error_id;
        if (decodeToken?.title_en)
          errorData.errorTitleEN = decodeToken?.title_en;
        if (decodeToken?.title_th)
          errorData.errorTitleTH = decodeToken?.title_th;
        if (decodeToken?.error_message_en)
          errorData.errorMessageEN = decodeToken?.error_message_en;
        if (decodeToken?.error_message_th)
          errorData.errorMessageTH = decodeToken?.error_message_th;

        if (decodeToken.error_id == 4006001) {
          // reset password - token expired
          errorData.errorTitleEN = "Your URL link has expire";
          errorData.errorMessageEN = `If you want to continue reset password, please re’ click here`;
        }
      }
    });

    return {
      errorCode,
      errorData,
      onLoginPage,
      logoChoco,
      forgetPasswordImg,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>

<style lang="scss" scoped>
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.content-login {
  background-color: transparent !important;
  box-shadow: none !important;
  width: 700px;
  height: auto;
  display: flex;
  // overflow: hidden;
  z-index: 1;
}
</style>
